import { simpleDateFormatter } from './dateFormatter';

export const downloadBlob = (blob, fileName, nameWithDate = true) => {
  const a = document.createElement('a');
  const url = window.URL.createObjectURL(blob);

  let fileNameWithExtension = fileName.replaceAll(' ', '_');

  if (nameWithDate) {
    fileNameWithExtension = fileNameWithExtension + '_' + simpleDateFormatter();
  }
  fileNameWithExtension = fileNameWithExtension + '.xlsx';

  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = url;
  a.download = fileNameWithExtension;
  a.click();

  window.URL.revokeObjectURL(url);
};
